import { callAPI } from "./core";

async function login(email, password) {
  return await callAPI(
    "/auth/login",
    "POST",
    { email: email, password: password },
    false
  );
}

async function refresh(refreshToken) {
  return await callAPI(
    "/auth/refresh",
    "POST",
    { refreshToken: refreshToken },
    false
  );
}

export { login, refresh };
